export const ACCOUNT_TAGS_OPEN_CLOSE_MERGE_TAGS_MODAL = "ACCOUNT_TAGS_OPEN_CLOSE_MERGE_TAGS_MODAL";

export const ACCOUNT_TAGS_MERGE_TAGS_SEARCH_ENTITIES = "ACCOUNT_TAGS_MERGE_TAGS_SEARCH_ENTITIES";
export const ACCOUNT_TAGS_MERGE_TAGS_SEARCH_ENTITIES_RESPONSE = "ACCOUNT_TAGS_MERGE_TAGS_SEARCH_ENTITIES_RESPONSE";

export const ACCOUNT_TAGS_MERGE_TAGS_SAVE = "ACCOUNT_TAGS_MERGE_TAGS_SAVE";
export const ACCOUNT_TAGS_MERGE_TAGS_SAVE_RESPONSE = "ACCOUNT_TAGS_MERGE_TAGS_SAVE_RESPONSE";